
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st1",attrs:{"fill":"#FFF","d":"M22 .5C34.2.5 43.4 10 43.4 22.1S34.2 44 22 44 0 34.2 0 22 9.9.5 22 .5z"}}),_c('path',{staticClass:"st2",attrs:{"fill":"#E60019","d":"M21.8 0C9.8 0 0 9.9 0 22c0 9.3 5.7 17.2 13.8 20.5v-.1c-.2-1.7-.4-4.3.1-6.1.4-1.7 2.5-10.9 2.5-10.9s-.6-1.3-.6-3.3c0-3.1 1.8-5.4 4-5.4 1.8 0 2.8 1.5 2.8 3.1 0 1.8-1.2 4.6-1.8 7.3-.5 2.2 1.1 4 3.3 4 3.9 0 6.9-4.2 6.9-10 0-5.3-3.8-8.9-9.1-8.9-6.2 0-9.8 4.6-9.8 9.5 0 1.8.7 3.9 1.6 5 .1.2.2.4.1.6-.1.7-.5 2.2-.6 2.4-.1.4-.4.5-.7.2C9.7 28.7 8 24.8 8 21.5c0-7 5-13.3 14.4-13.3 7.5 0 13.5 5.4 13.5 12.7 0 7.6-4.7 13.7-11.3 13.7-2.2 0-4.2-1.1-5-2.6 0 0-1.1 4.2-1.3 5.3-.5 2-1.8 4.3-2.7 5.7 2.1.6 4.2 1 6.5 1 12 0 21.8-9.9 21.8-22C44 9.2 33.8 0 21.8 0z"}})])
          )
        }
      }
    